// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-swbl-whrjLstd-index-main_right_content-18A30","table":"components-swbl-whrjLstd-index-table-1V1S3"};


//////////////////
// WEBPACK FOOTER
// ./components/swbl/whrjLstd/index.css
// module id = 2300
// module chunks = 0